export enum Text {
  Decline = 'Decline',
  CashToYou = 'Cash to You',
}
